jQuery(document).ready(function($){
	console.log('L\'A Cappella Theme');
});